<template lang="pug">
  div
    .field.is-horizontal.min-height(
      v-tooltip="{content: tooltip, show: showTooltip}"
    )
      label.label.font.is-pulled-left {{ gettext('Languages') }}
      .field-body
    transition-group(tag="div" name="fade")
      .lang-wrap(:key="language.id || index" v-for="(language, index) in items")
        .work-languages
          .field.is-horizontal(v-if="$v.value.$each[index]")
            .ections-icons(v-if="items.length > 1")
              i.mdi.mdi-close-box-outline.icon-delete(@click="remove(index)")
            .ections-icons(v-else)
              i.mdi.mdi-minus-circle-outline.icon-delete(@click="remove(index)")

            label.label.name {{ gettext('Language')+'*' }}
            .field-body(@click="validateData(index, 'language')")
              ajax-multiselect.is-single(
              v-model="language.language"
              :labelText="gettext('Choose the language')"
              itemName ="name"
              returnItem="id"
              :class="{'is-danger': $v.value.$each[index].language.$error, 'is-empty': !language.language}"
              :action="{method: 'receiveSpeakingLanguages', params: {lang: getLanguage}}"
              :multiple="false"
              :searchable="true"
              :hideSelected="true"
              :closeOnSelect="true"
              )
          .field.is-horizontal(v-if="$v.value.$each[index]")
            label.label.name {{ gettext('Level')+'*' }}
            .field-body(@click="validateData(index, 'level')")
              ajax-dropdown.wide(
              v-model="language.level"
              :labelText="gettext('Choose the level')"
              :itemName ="'name'"
              :returnItem ="'id'"
              :action="{method: 'receiveSpeakingLanguageLevels', params: {lang: getLanguage}}"
              :class="{'is-danger': $v.value.$each[index].level.$error, 'is-empty': !language.level}"
              )
        .field.is-horizontal.linned-bottom.min-height(v-if="items.length !== index+1")
          label.label.name
          .field-body

    .field.is-horizontal
      label.label
      .field-body
        .add(@click="add")
          i.mdi.mdi-plus-box.icon-plus
          span {{ gettext('Add another language') }}
</template>
<script>
import Vue from 'vue'
import { gettext } from '@/services/TranslateHandler'
import { mapGetters, mapActions } from 'vuex'
import AjaxDropdown from '@/components/ajax-dropdown'
import VDropdown from './components/dropdown'
import Vuelidate from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import VTooltip from 'v-tooltip'
import AjaxMultiselect from '@/components/ajax-multiselect'

Vue.use(VTooltip, {
  defaultTrigger: 'manual'
})

Vue.use(Vuelidate)

const _ = require('lodash')

export default {
  name: 'WorkLanguages',
  data () {
    return {
      showTooltip: false,
      selectedlanguages: [],
      languages: [],
      defaultValue: {
        id: 1,
        language: '',
        level: ''
      }
    }
  },
  props: {
    item: {
      default: 0
    },
    value: {
      default: () => {
        return []
      }
    },
    tooltip: {
      default: ''
    }
  },
  components: {
    AjaxDropdown,
    VDropdown,
    AjaxMultiselect
  },
  validations: {
    value: {
      $each: {
        language: {required},
        level: {required}
      }
    }
  },
  methods: {
    ...mapActions(['receiveSpeakingLanguages']),
    gettext: gettext,
    remove (item) {
      this.items.splice(item, 1)
      this.$v.value.$reset()
    },
    add () {
      if (this.defaultValue.id < this.languages.length) this.defaultValue.id = this.languages.length
      this.defaultValue.id++
      this.items = Object.assign({id: this.defaultValue.id}, this.defaultValue)
      this.$v.value.$reset()
    },
    validateData (index, attr) {
      if (index || attr) {
        this.$v.value.$each[index][attr].$touch()
        if (this.$v.$anyError) {
          this.showTooltip = true
        }

        setTimeout(() => {
          this.showTooltip = false
        }, 5000)
      } else {
        this.$v.$touch()
        if (this.$v.$anyError) {
          this.showTooltip = true
        }

        setTimeout(() => {
          this.showTooltip = false
        }, 5000)
      }
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    items: {
      get: function () {
        if (this.value.length < 1) {
          return [
            {
              id: 0,
              language: '',
              level: ''
            }
          ]
        } else {
          return this.value
        }
      },
      set: function (value) {
        if (this.value.length > 0) {
          this.value.push(value)
        } else {
          _.each(this.items, item => {
            this.value.push(item)
          })
          this.value.push(value)
        }
      }
    },
    formIsValid: function () {
      return !this.$v.$invalid
    },
    lang: function () {
      let languages = _.filter(this.languages, i => !_.find(this.value, {'language': i.id}))
      languages = _.sortBy(languages, 'name')
      return languages
    }
  },
  watch: {
    items: {
      deep: true,
      handler: function (value) {
        this.$emit('input', value)
      }
    },
    formIsValid: function (val) {
      if (val) this.$emit('valid', val)
    }
  },
  mounted () {
    this.$emit('input', this.items)
  },
  created () {
    this.receiveSpeakingLanguages({lang: this.getLanguage}).then(res => {
      this.languages = res
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/profile/cvs/cv/parts/work-languages/index.vue